export interface FaqConfig {
  // true = al cargar la pagina la primera pregunta viene desplegada (el diseño original).
  primera_abierta: boolean;
}

export const DEFAULT_FAQ_CONFIG: FaqConfig = { primera_abierta: true };

export function mergeFaqConfig(saved?: Partial<FaqConfig> | null): FaqConfig {
  return { primera_abierta: typeof saved?.primera_abierta === "boolean" ? saved.primera_abierta : true };
}
